"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxsProcessor = void 0;
var SimpleProcessor_1 = require("../common/SimpleProcessor");
var TxDocumentBuilder_1 = require("./TxDocumentBuilder");
var TxsProcessor = /** @class */ (function () {
    function TxsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.processor = new SimpleProcessor_1.SimpleProcessor(this.collectionNameBuilder, TxDocumentBuilder_1.TxDocumentBuilder.build);
    }
    TxsProcessor.prototype.process = function (batch) {
        return this.processor.process(batch.txs, batch);
    };
    return TxsProcessor;
}());
exports.TxsProcessor = TxsProcessor;
//# sourceMappingURL=TxsProcessor.js.map